<app-loading *ngIf="contentReady"></app-loading>

<section
  class="bbm-page"
  [class.rtl]="isAr"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="bbm-shell">

    <!-- HERO -->
    <section class="bbm-hero">

      <div class="bbm-hero-top">

        <div class="bbm-main-info">

          <div class="bbm-avatar">
            <i
              class="fa-solid fa-ticket"
              aria-hidden="true"
            ></i>
          </div>

          <div class="bbm-hero-copy">
            <span class="bbm-eyebrow">
              {{ 'promocode.badge' | transloco }}
            </span>

            <h2>
              {{ 'promocode.title' | transloco }}
            </h2>

            <p>
              {{ 'promocode.subtitle' | transloco }}
            </p>
          </div>

        </div>

        <div class="bbm-hero-counter">
          <strong>
            {{ allData.length }}
          </strong>

          <span>
            {{ 'promocode.totalCodes' | transloco }}
          </span>
        </div>

      </div>

    </section>

    <!-- PROMO CODE FORM -->
    <form
      class="bbm-form-ticket"
      [formGroup]="promocodeForm"
      (ngSubmit)="addCode()"
    >

      <div class="bbm-form-head">
        <div>
          <span class="bbm-eyebrow">
            {{ 'promocode.badge' | transloco }}
          </span>

          <h3>
            {{ 'promocode.title' | transloco }}
          </h3>

          <p>
            {{ 'promocode.subtitle' | transloco }}
          </p>
        </div>
      </div>

      <div class="bbm-form-grid">

        <!-- CODE -->
        <div class="bbm-field">
          <label for="code">
            {{ 'promocode.fields.code' | transloco }}
          </label>

          <input
            class="bbm-control"
            id="code"
            type="text"
            formControlName="code"
            [placeholder]="'promocode.placeholders.code' | transloco"
            [ngClass]="{
              'is-invalid':
                promocodeForm.get('code')?.touched &&
                promocodeForm.get('code')?.invalid,
              'is-valid':
                promocodeForm.get('code')?.touched &&
                promocodeForm.get('code')?.valid
            }"
          >
        </div>

        <!-- TYPE -->
        <div class="bbm-field">
          <label for="type">
            {{ 'promocode.fields.type' | transloco }}
          </label>

          <select
            class="bbm-control"
            id="type"
            formControlName="type"
          >
            <option value="0">
              {{ 'promocode.types.freeDelivery' | transloco }}
            </option>

            <option value="1">
              {{ 'promocode.types.discountPercentage' | transloco }}
            </option>
          </select>
        </div>

        <!-- PERCENTAGE -->
        <div class="bbm-field">
          <label for="percentage">
            {{ 'promocode.fields.percentage' | transloco }}
          </label>

          <input
            class="bbm-control"
            id="percentage"
            type="number"
            min="0"
            max="100"
            formControlName="percentage"
            [placeholder]="
              'promocode.placeholders.percentage'
                | transloco
            "
            [ngClass]="{
              'is-invalid':
                promocodeForm.get('percentage')?.touched &&
                promocodeForm.get('percentage')?.invalid,
              'is-valid':
                promocodeForm.get('percentage')?.touched &&
                promocodeForm.get('percentage')?.valid
            }"
          >
        </div>

        <!-- EXPIRATION DATE -->
        <div class="bbm-field">
          <label for="expiration_date">
            {{ 'promocode.fields.expirationDate' | transloco }}
          </label>

          <div class="bb-booking-calendar-field" [dir]="isAr ? 'rtl' : 'ltr'">
            <button
              type="button"
              class="bb-booking-calendar-trigger"
              id="expiration_date"
              (click)="toggleExpirationCalendar()"
              [ngClass]="{
                'is-valid': promocodeForm.get('expiration_date')?.value
              }"
            >
              <span>{{ getExpirationDateDisplay() }}</span>
              <i class="fa-solid fa-calendar-days"></i>
            </button>

            @if(showExpirationCalendar) {
            <div class="bb-booking-calendar-panel">
              <div class="bb-booking-calendar-head">
                <button type="button" (click)="previousExpirationCalendarMonth()">
                  <i class="fa-solid" [ngClass]="isAr ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
                </button>

                <strong>{{ getExpirationCalendarTitle() }}</strong>

                <button type="button" (click)="nextExpirationCalendarMonth()">
                  <i class="fa-solid" [ngClass]="isAr ? 'fa-chevron-left' : 'fa-chevron-right'"></i>
                </button>
              </div>

              <div class="bb-booking-calendar-weekdays">
                @for(dayName of getExpirationCalendarWeekDays(); track dayName) {
                <span>{{ dayName }}</span>
                }
              </div>

              <div class="bb-booking-calendar-grid">
                @for(calendarDay of getExpirationCalendarDays(); track calendarDay.date.getTime()) {
                <button
                  type="button"
                  class="bb-booking-calendar-day"
                  [class.other-month]="!calendarDay.isCurrentMonth"
                  [class.today]="calendarDay.isToday"
                  [class.selected]="calendarDay.isSelected"
                  [disabled]="calendarDay.isDisabled"
                  (click)="selectExpirationCalendarDate(calendarDay.date)"
                >
                  {{ calendarDay.dayNumber }}
                </button>
                }
              </div>
            </div>
            }
          </div>

          <input
            type="hidden"
            formControlName="expiration_date"
          >
        </div>

        <!-- ACTIVE STATUS -->
        <div class="bbm-modal-row bbm-field-wide">

          <label
            class="bbm-collapse-toggle"
            for="promo-active"
          >
            <span>
              <i
                class="fa-solid fa-toggle-on"
                aria-hidden="true"
              ></i>

              {{ 'promocode.fields.active' | transloco }}
            </span>

            <span class="bbm-switch">
              <input
                id="promo-active"
                type="checkbox"
                formControlName="active"
              >

              <span class="bbm-switch-track"></span>
            </span>
          </label>

        </div>

      </div>

      <!-- SUBMIT -->
      <div class="bbm-form-actions">

        <button
          class="
            bbm-action-btn
            bbm-action-success
            bbm-action-wide
          "
          type="submit"
          [disabled]="promocodeForm.invalid"
        >
          <i
            class="fa-solid fa-plus"
            aria-hidden="true"
          ></i>

          <span>
            {{ 'promocode.actions.submit' | transloco }}
          </span>
        </button>

      </div>

    </form>

    <!-- LIST HEADER -->
    <section class="bbm-list-head">

      <div>
        <span>
          {{ 'promocode.totalCodes' | transloco }}
        </span>

        <h3>
          {{ 'promocode.listTitle' | transloco }}
        </h3>
      </div>

      <strong class="bbm-list-counter">
        {{ visibleData.length }}
        /
        {{ allData.length }}
      </strong>

    </section>

    <!-- PROMO CODE CARDS -->
    <section
      class="bbm-ticket-list"
      *ngIf="!noData"
    >
      <article
        class="bbm-ticket"
        *ngFor="
          let element of visibleData;
          trackBy: trackById
        "
        [class.bbm-ticket-success]="element.active"
        [class.bbm-ticket-deleted]="!element.active"
      >

        <!-- CARD TOP -->
        <div class="bbm-ticket-top">

          <div class="bbm-main-info">

            <div class="bbm-avatar">
              <i
                class="fa-solid fa-ticket"
                aria-hidden="true"
              ></i>
            </div>

            <div class="bbm-copy">
              <span>
                {{ 'promocode.fields.code' | transloco }}
              </span>

              <h3 class="bbm-code-value">
                {{ element.code }}
              </h3>
            </div>

          </div>

          <span
            class="bbm-status-pill"
            [class.bbm-status-success]="element.active"
            [class.bbm-status-danger]="!element.active"
          >
            <i
              class="fa-solid"
              [class.fa-check]="element.active"
              [class.fa-xmark]="!element.active"
              aria-hidden="true"
            ></i>

            {{
              (
                element.active
                  ? 'promocode.status.on'
                  : 'promocode.status.off'
              ) | transloco
            }}
          </span>

        </div>

        <!-- PROMO DETAILS -->
        <div class="bbm-details-grid bbm-summary-grid">

          <!-- TYPE -->
          <div class="bbm-detail-chip bbm-detail-primary">
            <i
              class="fa-solid fa-tags"
              aria-hidden="true"
            ></i>

            <span>
              {{ 'promocode.fields.type' | transloco }}
            </span>

            <strong>
              {{
                (
                  element.type == 0
                    ? 'promocode.types.freeDelivery'
                    : 'promocode.types.discountPercentage'
                ) | transloco
              }}
            </strong>
          </div>

          <!-- PERCENTAGE -->
          <div
            class="bbm-detail-chip"
            [class.bbm-detail-success]="element.percentage"
          >
            <i
              class="fa-solid fa-percent"
              aria-hidden="true"
            ></i>

            <span>
              {{ 'promocode.fields.percentage' | transloco }}
            </span>

            <strong>
              <ng-container
                *ngIf="element.percentage; else noPercentage"
              >
                {{ element.percentage }}%
              </ng-container>

              <ng-template #noPercentage>
                -
              </ng-template>
            </strong>
          </div>

          <!-- EXPIRATION DATE -->
          <div class="bbm-detail-chip bbm-detail-wide">
            <i
              class="fa-regular fa-calendar"
              aria-hidden="true"
            ></i>

            <span>
              {{ 'promocode.fields.expirationDate' | transloco }}
            </span>

            <strong>
              <ng-container
                *ngIf="element.expiration_date; else noDate"
              >
                {{ element.expiration_date | date:'mediumDate' }}
              </ng-container>

              <ng-template #noDate>
                -
              </ng-template>
            </strong>
          </div>

        </div>

        <!-- DELETE ACTION -->
        <div class="bbm-actions-grid bbm-ticket-section">

          <button
            class="
              bbm-action-btn
              bbm-action-danger
              bbm-action-wide
            "
            type="button"
            (click)="deleteItem(element.id)"
          >
            <i
              class="fa-solid fa-trash"
              aria-hidden="true"
            ></i>

            <span>
              {{ 'promocode.actions.delete' | transloco }}
            </span>
          </button>

        </div>

      </article>
    </section>

    <!-- NO DATA -->
    <div
      *ngIf="noData && !contentReady"
      class="bbm-empty-state"
    >
      <app-nodata></app-nodata>
    </div>

    <!-- LOAD MORE / SCROLL HINT -->
    <div
      class="bbm-alert bbm-alert-primary"
      *ngIf="hasMore && !contentReady"
    >
      <i
        class="fa-solid fa-angles-down"
        aria-hidden="true"
      ></i>

      <span>
        {{ 'promocode.scrollHint' | transloco }}
      </span>
    </div>

    <!-- END STATE -->
    <div
      class="bbm-end-state"
      *ngIf="!hasMore && !noData && !contentReady"
    >
      {{ 'promocode.endOfList' | transloco }}
    </div>

  </div>
</section>